<div [formGroup]="formUser" class="custom-container p-1">
    <div class="mb-3">
        <ng-select
            [items]="processedEntities()"
            [multiple]="true"
            [selectableGroup]="true"
            groupBy="campus"
            [hideSelected]="true"
            [closeOnSelect]="false"
            [selectableGroupAsModel]="false"
            bindLabel="label"
            [compareWith]="compareByCode"
            formControlName="entities"
            placeholder="Escribe para buscar..."
            [virtualScroll]="true">

            <ng-template ng-option-tmp let-item="item">
                <div class="d-flex justify-content-between align-items-center">
                    <span [class.text-muted]="item.disabled" [class.fw-normal]="!item.disabled">
                        {{ item.label }}
                    </span>
                    @if (item.disabled) {
                    <span class="badge bg-secondary ms-2 small">Sin acceso</span>
                    }
                </div>
            </ng-template>

            <ng-template ng-footer-tmp>
                <div class="p-2 border-top small">
                    <span class="text-info"><i class="fas fa-info-circle"></i></span>
                    Entidades seleccionadas: <strong>{{ formUser.get('entities')?.value?.length || 0 }}</strong>
                </div>
            </ng-template>
        </ng-select>

        @if (formUser.get('entities')?.errors?.required && formUser.get('entities')?.touched) {
        <div class="text-danger mt-1 small">
            <i class="fas fa-exclamation-triangle"></i> Debes seleccionar al menos una entidad.
        </div>
        }
    </div>
</div>
